const middleware = {}

middleware['product2025-redirects'] = require('../src/middleware/product2025-redirects.js')
middleware['product2025-redirects'] = middleware['product2025-redirects'].default || middleware['product2025-redirects']

export default middleware
